import React, { useEffect } from "react";
import { Button, ButtonProps, Typography } from "@mui/material";
import Loader from "../loading-screen/Loader";

type CustomLoadingButtonProps = ButtonProps & {
  loading?: boolean;
  sx?: any;
};

export default function CustomLoadingButton({
  children,
  loading = false,
  sx,
  ...props
}: CustomLoadingButtonProps) {
  return (
    <Button
      {...props}
      disabled={loading || props.disabled}
      sx={{
        px: 5,
        py: 1,
        position: "relative",
        // color: loading ? "transparent" : "white", // Prevent flicker
        "&.Mui-disabled": {
          bgcolor: (theme) => theme.palette.action.disabledBackground,
        },
        ...sx,
      }}
    >
      {children}
      {loading && (
        <span
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Loader width={30} />
        </span>
      )}
    </Button>
  );
}
